// Collections
export const SET_COLLECTIONS = 'SET_COLLECTIONS'
export const SET_COLLECTIONS_IS_LOADING = 'SET_COLLECTIONS_IS_LOADING'
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'

// Products
export const SET_PRODUCTS = 'SET_PRODUCTS'

// Redemptions
export const SET_TICKETS = 'SET_TICKETS'
export const SET_TICKETS_PAGINATION = 'SET_TICKETS_PAGINATION'
export const SET_TICKETS_REDEEMED = 'SET_TICKETS_REDEEMED'
export const SET_TICKETS_EXPIRED = 'SET_TICKETS_EXPIRED'
export const SET_TICKETS_TO_EMPTY = 'SET_TICKETS_TO_EMPTY'
export const SET_REDEMPTION_TAB = 'SET_REDEMPTION_TAB'
export const SET_REDEMPTION_GROUP = 'SET_REDEMPTION_GROUP'
export const SET_REDEMPTION_GROUP_TO_EMPTY = 'SET_REDEMPTION_GROUP_TO_EMPTY'
export const SET_QR_CODE = 'SET_QR_CODE'
export const SET_ALL_QR_CODE = 'SET_ALL_QR_CODE'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'

// Checkout
export const SET_CHECKOUT_CART = 'SET_CHECKOUT'
export const UPDATE_LINE = 'UPDATE_LINE'
export const REMOVE_LINE = 'REMOVE_LINE'
export const SET_CHECKOUT_STEP = 'SET_CHECKOUT_STEP'
export const SET_CHECKOUT_SUB_STEP = 'SET_CHECKOUT_SUB_STEP'
export const SET_TAGS = 'SET_TAGS'
export const SET_TAG = 'SET_TAG'
export const SET_IS_CHECKOUT_DETAIL = 'SET_IS_CHECKOUT_DETAIL'
export const SET_QUERY = 'SET_QUERY'

// Auth
export const AUTH_ENUM_OTP_TYPE = { LOGIN: 'LOGIN', SIGNUP: 'SIGNUP' }
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN'
export const AUTH_SET_IAT = 'AUTH_SET_IAT'
export const AUTH_SET_SETUP_COMPLETE = 'AUTH_SET_SETUP_COMPLETE'
export const AUTH_SET_OTP_TOKEN = 'AUTH_SET_OTP_TOKEN'
export const AUTH_SET_OTP_NUMBER = 'AUTH_SET_OTP_NUMBER'
export const AUTH_SET_OTP_TYPE = 'AUTH_SET_OTP_TYPE'
export const AUTH_SET_REDIRECT = 'AUTH_SET_REDIRECT'
export const AUTH_SET_REDIRECT_LINK = 'AUTH_SET_REDIRECT_LINK'
export const AUTH_SET_OTP_SENT_TIME = 'AUTH_SET_OTP_SENT_TIME'
export const AUTH_UNSET_OTP_SENT_TIME = 'AUTH_UNSET_OTP_SENT_TIME'
export const AUTH_SET_FORCE_REDIRECT = 'AUTH_SET_FORCE_REDIRECT'
export const AUTH_SET_SESSION = 'AUTH_SET_SESSION'
export const AUTH_SET_AGREED_TO_TERMS = 'AUTH_SET_AGREED_TO_TERMS'
export const AUTH_SET_AGREED_TO_PROMOTIONS = 'AUTH_SET_AGREED_TO_PROMOTIONS'
export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT'
export const AUTH_DISPATCH_RESEND_OTP = 'AUTH_DISPATCH_RESEND_OTP'
export const AUTH_DISPATCH_SIGNUP = 'AUTH_DISPATCH_SIGNUP'
export const AUTH_DISPATCH_LOGIN_SINGPASS = 'AUTH_DISPATCH_LOGIN_SINGPASS'
export const AUTH_DISPATCH_LOGIN = 'AUTH_DISPATCH_LOGIN'
export const AUTH_DISPATCH_VERIFY_OTP = 'AUTH_DISPATCH_VERIFY_OTP'
export const AUTH_DISPATCH_LOAD_PROFILE = 'AUTH_DISPATCH_LOAD_PROFILE'
export const AUTH_DISPATCH_LOAD_USER_SINGPASS = 'AUTH_DISPATCH_LOAD_USER_SINGPASS'
export const AUTH_DISPATCH_SET_NRIC = 'AUTH_DISPATCH_SET_NRIC'
export const AUTH_DISPATCH_SET_EMAIL = 'AUTH_DISPATCH_SET_EMAIL'
export const AUTH_DISPATCH_REMOVE_NRIC = 'AUTH_DISPATCH_REMOVE_NRIC'
export const AUTH_DISPATCH_TOKEN_NACCC = 'AUTH_DISPATCH_TOKEN_NACCC'
export const AUTH_DISPATCH_LOGOUT = 'AUTH_DISPATCH_LOGOUT'
export const AUTH_DISPATCH_SET_AGREEMENTS = 'AUTH_DISPATCH_SET_AGREEMENTS'
export const AUTH_DISPATCH_GET_HERITAGE_ID = 'AUTH_DISPATCH_GET_HERITAGE_ID'
export const AUTH_DISPATCH_GUEST_LOGIN = 'AUTH_DISPATCH_GUEST_LOGIN'
export const AUTH_SET_GUEST_LOGIN = 'AUTH_SET_GUEST_LOGIN'
export const AUTH_DISPATCH_GUEST_LOGOUT = 'AUTH_DISPATCH_GUEST_LOGOUT'
export const AUTH_GUEST_LOGOUT = 'AUTH_GUEST_LOGOUT'
export const AUTH_SET_CREDENTIAL = 'AUTH_SET_CREDENTIAL'
export const AUTH_SET_PROFILE = 'AUTH_SET_PROFILE'
export const AUTH_SET_ISVERIFY_SINGPASS = 'AUTH_SET_ISVERIFY_SINGPASS'
export const AUTH_SET_USER_SINGPASS = 'AUTH_SET_USER_SINGPASS'
export const AUTH_SET_STATUS_SINGPASS = 'AUTH_SET_STATUS_SINGPASS'
export const AUTH_SET_ERROR_SINGPASS = 'AUTH_SET_ERROR_SINGPASS'
export const AUTH_SET_ISFOUND_ANOTHER_ACCOUNT = 'AUTH_SET_ISFOUND_ANOTHER_ACCOUNT'
export const AUTH_GIFT_INFO = 'AUTH_GIFT_INFO'
export const AUTH_GIFT_REDEEM = 'AUTH_GIFT_REDEEM'
export const AUTH_EXPIRED_TOKEN = 'AUTH_EXPIRED_TOKEN'
export const AUTH_SET_OTP_EMAIL = 'AUTH_SET_OTP_EMAIL'
export const AUTH_EXPIRED_TOKEN_NACCC = 'AUTH_EXPIRED_TOKEN_NACCC'
export const AUTH_NACCC_TOKEN = 'AUTH_NACCC_TOKEN'
export const AUTH_FALLBACK_URL = 'AUTH_FALLBACK_URL'
export const AUTH_HERITAGE_JOURNEY = 'AUTH_HERITAGE_JOURNEY'

// language
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE'

// Shopify credentials
export const SET_CREDENTIALS_IS_LOADED = 'SET_CREDENTIALS_IS_LOADED'
export const SET_GOOGLE_TAG_MANAGER_IDS_IS_LOADED = 'SET_GOOGLE_TAG_MANAGER_IDS_IS_LOADED'
export const SET_ACHIEVEMENT_GROUPS = 'SET_ACHIEVEMENT_GROUPS'
export const SET_ADHOC_TICKET_CONDITION = 'SET_ADHOC_TICKET_CONDITION'
export const SET_TICKET_LEGEND = 'SET_TICKET_LEGEND'
export const SET_ACHIEVEMENT_MEDIAS = 'SET_ACHIEVEMENT_MEDIAS'
export const CLEAR_ACHIEVEMENT_MEDIAS = 'CLEAR_ACHIEVEMENT_MEDIAS'
export const SET_TRANSACTION_LIMIT = 'SET_TRANSACTION_LIMIT'
export const SET_TRANSACTION_LIMIT_MESSAGE = 'SET_TRANSACTION_LIMIT_MESSAGE'
export const SET_IS_TRANSACTION_LIMIT_REACHED = 'SET_IS_TRANSACTION_LIMIT_REACHED'
export const SET_ACKNOWLEDGMENT = 'SET_ACKNOWLEDGMENT'

export const SET_TICKET_PRICE = 'SET_TICKET_PRICE'

// Navigation
export const SET_HISTORY_COUNT = 'SET_HISTORY_COUNT'

//Alerts
export const SET_ALERT_CONTENT = 'SET_ALERT_CONTENT'

// Timeslot booking
export const SET_BOOKING_ID = 'SET_BOOKING_ID'
export const SET_BOOKING_DATA = 'SET_BOOKING_DATA'
export const RESET_DATA = 'RESET_DATA'

//Ticket
export const SET_TICKET = 'SET_TICKET'
export const SET_SKU = 'SET_SKU'

//Hold-booking
export const SET_STATUS = 'SET_STATUS'
export const SET_BOOKING = 'SET_BOOKING'

//Rating
export const SET_SHOW_RATING = 'SET_SHOW_RATING'
export const SUBMIT_RATING = 'SUBMIT_RATING'


//Settings
export const SET_SETTINGS = 'SET_SETTINGS'

//Facility
export const SET_ACTIVITIES = 'SET_ACTIVITIES'

//Cart
export const SET_CART = 'SET_CART'
export const LOAD_CART = 'LOAD_CART'
export const CREATE_CART = 'CREATE_CART'
export const UPDATE_CART = 'UPDATE_CART'
export const DELETE_CART = 'DELETE_CART'
export const ADD_CART_ITEMS = 'ADD_CART_ITEMS'
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM'
export const UPDATE_CART_ITEMS = 'UPDATE_CART_ITEMS'
export const DELETE_CART_ITEM = 'DELETE_CART_ITEM'
export const DELETE_BOOKINGS = 'DELETE_BOOKINGS'
export const SET_PREVIOUS_PRODUCT_URL = 'SET_PREVIOUS_PRODUCT_URL'
export const SET_CART_ACTIVITIES = 'SET_CART_ACTIVITIES'
export const SET_CART_VACANCIES = 'SET_CART_VACANCIES'
